import React from "react";
import PropTypes from "prop-types";

import { format } from "date-fns";

const LongDate = ({ date, ...rest }) => (
  <span {...rest}>{format(date, "Do MMMM YYYY")}</span>
);

LongDate.propTypes = {
  date: PropTypes.string.isRequired
};

export default LongDate;
